import React from "react";
import { Button, Control, Field, Input } from "@allxsmith/bestax-bulma";


export default function SearchBar({handleSearch, searchText, setSearchText, clear, inputTestId="", searchButtonTestId=""}){

    return (
      <Field className="has-addons">
        <Control>
          <Input
            onChange={e => setSearchText(e.target.value)}
            onKeyPress={e => (e.key === 'Enter' || e.keyCode === 13) && handleSearch()}
            name="search_text"
            type="text"
            placeholder="Search"
            value={searchText}
            data-testid={inputTestId}
          ></Input>
        </Control>
        <Control>
          <Button onClick={handleSearch} type="primary" data-testid={searchButtonTestId}>
            Search
          </Button>
        </Control>
        <Control>
          <Button onClick={clear} color="warning">
            Clear
          </Button>
        </Control>
      </Field>
    );
}